import React, { useState } from 'react';
import Inquiry from './Inquiry';
import Orders from './Orders';
import Quotation from './Quotation';


function OrderDetail({selectedChat}) {
  const [activeTab, setActiveTab] = useState('Orders');
  console.log("selectedChat:",selectedChat);
  

  return (
    <div className="container h-[100%] mx-auto p-6 border rounded-lg shadow-lg">
      <div className="header flex justify-between items-center mb-4">
        <h2 className="text-2xl font-bold">Conversation</h2>
        <button className="bg-orange-500 text-white px-4 py-2 rounded-lg hover:bg-orange-600">
          Add Contact
        </button>
      </div>
      <p className="text-gray-700 mb-4">Shenzhen Great Asia Electronic Co., Ltd.</p>
      <div className="tabs flex space-x-4 mb-6 border-b">
        <button
          onClick={() => setActiveTab('Inquiry')}
          className={`px-4 py-2 ${
            activeTab === 'Inquiry' ? 'border-b-2 border-blue500 font-semibold' : 'text-[#4A5568]'
          }`}
        >
          Inquiry
        </button>
        <button
          onClick={() => setActiveTab('Quotation')}
          className={`px-4 py-2 ${
            activeTab === 'Quotation' ? 'border-b-2 border-blue500 font-semibold' : 'text-[#4A5568]'
          }`}
        >
          Quotation
        </button>
        <button
          onClick={() => setActiveTab('Orders')}
          className={`px-4 py-2 ${
            activeTab === 'Orders' ? 'border-b-2 border-blue500 font-semibold' : 'text-[#4A5568]'
          }`}
        >
          Orders
        </button>
      </div>
      <div className="content">
        {activeTab === 'Inquiry' && <Inquiry />}
        {activeTab === 'Quotation' && <Quotation />}
        {activeTab === 'Orders' && <Orders />}
      </div>
    </div>
  );
}

export default OrderDetail;
